(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TradePolicyRuleEffect', TradePolicyRuleEffect);

    TradePolicyRuleEffect.$inject = ['$resource'];

    function TradePolicyRuleEffect ($resource) {
        var resourceUrl =  'api/trade-policy-rule-effects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
